import loading from './assets/loading.json';
import buttonLoading from './assets/button-loading.json';

export const SPINNER_TYPES = {
  loading,
  buttonLoading
};
